import { render, staticRenderFns } from "./bkGrid.vue?vue&type=template&id=bf643792&scoped=true&"
import script from "./bkGrid.vue?vue&type=script&lang=js&"
export * from "./bkGrid.vue?vue&type=script&lang=js&"
import style0 from "./bkGrid.vue?vue&type=style&index=0&id=bf643792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf643792",
  null
  
)

export default component.exports